import { Validator } from "fluentvalidation-ts";
import { matchIsValidTel } from "mui-tel-input";

type Operator = {
  
  cellNumber: string,
  email: string,
  name: string,
  phoneNumber: string,
  surname: string,
  maintenanceCompany:number; };
 

class OperatorValidator extends Validator<Operator> {
  constructor() {
    super();

    this.ruleFor("name")
      .notNull()
     .withMessage("Campo obbligatorio");
    
     this.ruleFor("surname")
     .notNull()
    .withMessage("Campo obbligatorio");
   

     this.ruleFor("maintenanceCompany")
     .notNull()
    .withMessage("Campo obbligatorio");

    this.ruleFor("cellNumber") // This is type-safe! (Argument is of type 'name' | 'age')
      .notNull()
      .notEmpty()
      .withMessage("Perfavore inserisci un numero di telefono")
      .must((phone) => matchIsValidTel(phone))
      .withMessage("Numero non valido");

    this.ruleFor("email")
      .notNull()
      .notEmpty()
      .withMessage("Perfavore inserisci la tua e-mail")
      .emailAddress()
      .withMessage("E-mail non valida");

  }
  
}

export default OperatorValidator;
